import React from 'react'
import { ChevronLeft } from 'react-bootstrap-icons'
const MenuBrowser = ({ setPage }) => {
  return (
    <div className="mt-4 h-[50px]">
      <div
        className="flex h-12 w-full items-center gap-x-4 py-4"
        onClick={() => {
          setPage('home')
        }}
      >
        <ChevronLeft className="text-gray-1100" />
        <span className="text-xl !font-medium !text-gray-1100">Main Menu</span>
      </div>
      <div className="h-px w-full bg-gray-300"></div>
    </div>
  )
}

export default MenuBrowser
